import React from "react";
import {Box, Icon, Tooltip} from "@chakra-ui/react";
import {CheckIcon} from "@chakra-ui/icons";

// Verification tiers for a school. The look of each tier is defined here so the
// badge stays consistent everywhere it's rendered (list rows, detail header…).
export const VERIFIED_TIERS = {
    gold: {
        label: "Golden Verified",
        gradient: "linear(135deg, #FDE08D 0%, #F5B301 55%, #B97E00 100%)",
        ring: "#F5B301",
    },
    silver: {
        label: "Silver Verified",
        gradient: "linear(135deg, #F2F4F7 0%, #C2CAD3 55%, #8B96A3 100%)",
        ring: "#C2CAD3",
    },
};

// Normalize whatever the backend eventually sends (e.g. "GOLD", "gold",
// "GOLDEN", "silver_tier") to one of our tier keys. Returns null when there is
// no recognizable tier so the badge simply doesn't render.
export const normalizeTier = (value) => {
    if (!value) return null;
    const v = String(value).toLowerCase();
    if (v.includes("gold")) return "gold";
    if (v.includes("silver")) return "silver";
    return null;
};

const SIZES = {
    sm: {box: "14px", icon: "8px"},
    md: {box: "18px", icon: "11px"},
    lg: {box: "22px", icon: "13px"},
};

// A Twitter/X-style verification badge: a tinted circle with a white check.
// Renders nothing unless `tier` resolves to a known tier.
function VerifiedTick({tier, size = "md", showTooltip = true, ...rest}) {
    const key = normalizeTier(tier);
    if (!key) return null;

    const meta = VERIFIED_TIERS[key];
    const dim = SIZES[size] || SIZES.md;

    const badge = (
        <Box
            as="span"
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            boxSize={dim.box}
            borderRadius="full"
            bgGradient={meta.gradient}
            boxShadow={`0 0 0 1.5px white, 0 1px 2px rgba(0,0,0,0.25)`}
            flexShrink={0}
            aria-label={meta.label}
            {...rest}
        >
            <Icon as={CheckIcon} color="white" boxSize={dim.icon}/>
        </Box>
    );

    if (!showTooltip) return badge;

    return (
        <Tooltip label={meta.label} placement="top" hasArrow>
            {badge}
        </Tooltip>
    );
}

export default VerifiedTick;
